// extracted by mini-css-extract-plugin
export default {"error":"notification__error___ZS1UN","warning":"notification__warning___RvsrI","regular":"notification__regular___D71mj"};